import SkipToContent from './skip-to-content'

export default SkipToContent
